
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/tables",
      function () {
        return require("private-next-pages/components/tables.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/tables"])
      });
    }
  